import { render, staticRenderFns } from "./ChapterMembers.vue?vue&type=template&id=01789064"
import script from "./ChapterMembers.vue?vue&type=script&lang=js"
export * from "./ChapterMembers.vue?vue&type=script&lang=js"
import style0 from "./ChapterMembers.vue?vue&type=style&index=0&id=01789064&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports